


import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const AssessmentCompletionMessage = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        p: 3,
      }}
    >
      <Paper
        elevation={3} // Increased elevation for a more prominent shadow
        sx={{
          maxWidth: 450, // Slightly reduced maxWidth for a more focused card
          width: '100%',
          p: 5,
          textAlign: 'center',
          borderRadius: 3,
          background: 'linear-gradient(145deg, #ffffff, #f0f8ff)', // Subtle, elegant gradient
          boxShadow: '0 8px 30px rgba(0,0,0,0.1)', // Softer, more modern shadow
          border: '1px solid #e0e0e0', // Light border for definition
        }}
      >
        <CheckCircleOutlineIcon
          sx={{
            fontSize: 80, // Larger icon
            color: '#4caf50', // A more vibrant, standard success green
            mb: 2,
            filter: 'drop-shadow(0 2px 4px rgba(76, 175, 80, 0.4))', // Subtle shadow on the icon
          }}
        />
        <Typography
          variant="h4" // Larger heading for better hierarchy
          fontWeight="bold"
          gutterBottom
          sx={{ color: '#263238' }} // Darker, more professional text color
        >
          Assessment Complete
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          gutterBottom
          sx={{ color: '#546e7a' }} // Muted text for secondary info
        >
          Thank you for completing the assessment. Your responses have been successfully submitted.
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 3, color: '#78909c' }} // Slightly lighter, tertiary text
        >
          You can now safely close this window.
        </Typography>
      </Paper>
    </Box>
  );
};

export default AssessmentCompletionMessage;